// extracted by mini-css-extract-plugin
export default {"title":"title--PLgCK","m":"m--KKA8K","l":"l--iGP_q","blink":"blink--NIEyi"};